const [w] = [window]

// HTML読み込みプラグイン
export default function loadHtml (obj, option) {
  var g_opt = $.extend({
    src: '/src/html/',
    extention: '.html',
    timestamp:''
  },option);
  var defs = []
  if( w.load && !w.load['loadHtml'] ) w.load['loadHtml'] = new $.Deferred;
  $(obj).each(function(){
    w.load = w.load||{};
    var $this = $(this),
        opt = $.extend(true,{},g_opt,$this.data()),
        request_url = `${opt.src}${opt.loadHtml}${opt.extention}`
    w.load[ opt.name ? opt.name : opt.loadHtml ] = new $.Deferred;
    defs.push( w.load[ opt.name ? opt.name : opt.loadHtml ].promise() )
    $.get(request_url+(opt.timestamp?'?ts='+opt.timestamp:''),function(html){
      $this.replaceWith(html);
      console.info('%c%s%c is loaded','font-weight: bold',this.url,'');
      w.load[ opt.name ? opt.name : opt.loadHtml ].resolve(html);
      $(w).trigger($this.data().loadHtml+'.load');
    });
  });
  $.when.apply( $, defs ).then(function() {
    w.load['loadHtml'].resolve();
  });
  return obj;
}
